// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import HeightController from "./height_controller"
application.register("height", HeightController)

import ReadMoreController from "./read_more_controller"
application.register("read-more", ReadMoreController)

import ScreenHeightController from "./screen_height_controller"
application.register("screen-height", ScreenHeightController)

import ScrollController from "./scroll_controller"
application.register("scroll", ScrollController)

import SliderController from "./slider_controller"
application.register("slider", SliderController)

import VisibilityController from "./visibility_controller"
application.register("visibility", VisibilityController)
